import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import chevronLeft from '@starbucks-web/pattern-library/lib/icons/chevron-left';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';

import { Allergens } from './allergens';
import ColumnsTemplate from '../columns-template';
import { Ingredients } from './ingredients';
import Nutrition from './nutrition';
import { usePdpContext } from '../pdp-provider';

import messages from './messages';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

const NutritionSection = () => {
  const {
    product: { name, productType },
  } = usePdpContext();

  const location = useLocation();
  const mainPdpPath = location?.pathname?.split('/nutrition')?.[0];

  const intl = useIntl();

  const leftColumn = <Nutrition />;

  const rightColumn = productType !== 'coffees' && (
    <React.Fragment>
      <Ingredients />
      <Allergens />
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <Helmet
        title={`${name}: ${intl.formatMessage(messages.nutritionTitle)}`}
      />
      <Link
        className="block mb5 text-noUnderline text-semibold "
        data-e2e="backLink"
        to={mainPdpPath}
      >
        <Icon className="pr1" path={chevronLeft} size="24px" />
        <FormattedMessage {...sharedCallsToAction.back} />
      </Link>
      <ColumnsTemplate
        isNutritionPage
        leftColumn={leftColumn}
        rightColumn={rightColumn}
      />
    </React.Fragment>
  );
};

export default NutritionSection;
